<!-- START: App Load Failure Overlay -->
@if (loadFailed()) {
  <div
    class="load-failure flex-row justify-center align-center"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="load-failure-title"
    aria-describedby="load-failure-desc"
  >
    <!-- Failure panel (traps focus and auto-focuses the reload action) -->
    <section class="load-failure__panel flex-column align-center gap-16" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
      <!-- Title -->
      <h1 id="load-failure-title" class="load-failure__title">
        Something went wrong loading the application
      </h1>
      <!-- Explanation -->
      <p id="load-failure-desc" class="load-failure__message">
        We couldn't finish loading part of the page. This can happen right after an update. Reloading usually fixes it.
      </p>
      <!-- Reload action -->
      <fsx-button
        [label]="'Reload'"
        [buttonType]="FsxButtonTypeEnum.Primary"
        (onClickedEvent)="onReloadClicked()"
      ></fsx-button>
    </section>
  </div>
}
<!-- END: App Load Failure Overlay -->
